import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { logEventGA4 } from '../../google';
import { migrateReduxSessionStorageFilterValue, sessionStorageMF } from '../../utils';
import { setFilterValue } from '../filterValue';

const initialState = {
  display: 'Gender',
  name: 'doctorGender',
  type: 'singleSelect',
  selected: { value: '', display: 'Any' },
  options: [
    { value: '', display: 'Any' },
    { value: 'M', display: 'Male' },
    { value: 'F', display: 'Female' },
    // { value: 'NB', display: 'Non-Binary' }, Not in use until we get more data
  ],
};

const storeName = 'doctorGender';
export const useDoctorGenderFilter = create(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        set,
        reset: () => set({ ...initialState }, false, { type: 'reset' }),
        getInitialState: () => ({ ...initialState }),
        setFilterValue: (v) => updateDoctorGenderFilterOption(v),
      }),
      {
        name: `${process.env.NX_APP}-${storeName}`,
        version: 0,
        storage: createJSONStorage(() => sessionStorageMF),
        onRehydrateStorage: () => (state) => {
          migrateReduxSessionStorageFilterValue({ state, key: 'doctorGender' });
        },
      },
    ),
    {
      name: `${process.env.NX_APP}`,
      store: storeName,
    },
  ),
);

export const updateDoctorGenderFilterOption = (option) => {
  if (option && process.env.NX_APP === 'MediFind-Pro') {
    const { value } = option;
    logEventGA4('filter', { type: 'doctor_gender', action: 'select', item_id: value }, 'cb6f89c7-ffe1-4334-a33a-7685c6485af6');
  }
  setFilterValue(useDoctorGenderFilter, option);
};

export const clearDoctorGenderFilterOption = () =>
  useDoctorGenderFilter.setState({ ...initialState }, false, {
    type: 'clearDoctorGenderFilterOption',
  });
